module.exports = __webpack_public_path__ + "media/companies/Zaoui&Co-919002f5.png";